<template>
  <div class="sign-in">
    <modal width="100%" height="100vh" :hideCloseButton="true">
      <div slot="body" class="body">
        <transition name="fade">
          <header class="header" v-if="!hideHeader">
            <h1 v-html="$t('Web.Login.Header')"></h1>
            <!-- <img
              src="./../../assets/img/img-placeholder-app-icon.png"
              v-bind:srcset="`${appIcons[0]} 2x, ${appIcons[1]} 3x`"
              class="img-placeholder-app-icon"
            /> -->
            <junelight-disclaimer class="junelight-disclaimer"></junelight-disclaimer>
          </header>
        </transition>

        <div class="authenticator">
          <cactus-authenticator class="jl-authenticator" />
        </div>
        <div class="additionalFields">
          <legal-disclaimer v-if="footerMap.showLegalDisclaimer" />
          <service-person v-if="footerMap.showServiceContact" />
        </div>
      </div>
      <div slot="footer" class="footer"></div>
    </modal>
  </div>
</template>

<script>
import Modal from './modal.vue';
import LegalDisclaimer from '../_common/legalDisclaimer';
import ServicePerson from '../_common/servicePerson';
import { CactusEventBus } from '@cactus-web/authenticator';
import JunelightDisclaimer from './junelightDisclaimer.vue';

/*
 *
 * Workaraound as vue-html-loader ignores srcset
 *
 */
const appIcons = [
  require('./../../assets/img/img-placeholder-app-icon@2x.png'),
  require('./../../assets/img/img-placeholder-app-icon@3x.png')
];

export default {
  name: 'signIn',
  components: {
    Modal,
    LegalDisclaimer,
    ServicePerson,
    JunelightDisclaimer
  },
  data() {
    return {
      footerMap: {},
      currentAuthState: '',
      signUpConfig: { signUpConfig: 'legal-disclaimer' }
    };
  },
  mounted() {
    CactusEventBus.$on('authState', authState => {
      this.currentAuthState = authState;
      this.footerMap = this.updateFooterContent(authState);
    });
  },
  computed: {
    appIcons() {
      return appIcons;
    },
    hideHeader() {
      return this.currentAuthState === 'passwordForgotten' || this.currentAuthState === 'signUp';
    }
  },
  methods: {
    updateFooterContent(state) {
      return {
        showLegalDisclaimer: state === 'signUp',
        showServiceContact: state === 'passwordForgotten'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.junelight-disclaimer {
  margin-top: 3rem;
}

.sign-in {
  .body {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .jl-authenticator {
    width: $maxWidth;
  }
}

.modal-mask {
  background-color: $pale-grey;
}

.header {
  h1 {
    @include headlineApp;
    margin-top: 100px;
  }
  img {
    display: block;
    margin: 0 auto;
  }
}

.authenticator {
  margin-top: 25px;
}

.additionalFields {
  margin-top: 25px;
}

.fade-enter-active {
  transition-duration: 0.25s;
}

.fade-leave-active {
  transition-duration: 0.25s;
}

.fade-leave,
.fade-enter-to {
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
